import Vue from 'vue';

// Noop the directive. Possibly open this up to QA E2E testing later
Vue.directive('test', {});
